import React, { useEffect, useState } from 'react'
import styles from './Home.module.css'

const Home = () => {
  const HOME_BODY_CLASS = 'homePage'
  const heroBackgrounds = [
    'images/ge.jpg',
    'images/whirlpool.jpg',
    'images/frigidaire.jpg',
  ]
  const foundingYear = 1988
  const yearsInBusiness = Math.max(0, new Date().getFullYear() - foundingYear)
  const brandLogos = [
    'air-king_1.png',
    'amana_1.png',
    'avanti_orig.png',
    'blomberg.png',
    'bosch_1.png',
    'broan.png',
    'electrolux.png',
    'fisher-paykel.png',
    'friedrich.png',
    'frigidaire.png',
    'gaggenau.png',
    'ge.png',
    'hotpoint.png',
    'kitchenaid.png',
    'lg.png',
    'marvel.png',
    'maytag.png',
    'monogram.png',
    'premier.png',
    'sharp.png',
    'speed-queen.png',
    'summit.png',
    'thermador.png',
    'viking-2.png',
    'whirlpool.png',
    'zephyr.png',
  ]
  const [heroIndex, setHeroIndex] = useState(0)
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
  })
  const [formStatus, setFormStatus] = useState({ state: 'idle', error: '' })
  const [modalClosing, setModalClosing] = useState(false)
  const [activeModal, setActiveModal] = useState(null)
  const [showScrollTop, setShowScrollTop] = useState(false)
  const [brandIndex, setBrandIndex] = useState(0)
  const [brandOffset, setBrandOffset] = useState(0)
  const [brandDirection, setBrandDirection] = useState(null)
  const [isBrandAnimating, setIsBrandAnimating] = useState(false)
  const brandTimer = React.useRef(null)

  useEffect(() => {
    document.body.classList.add(HOME_BODY_CLASS)
    return () => {
      document.body.classList.remove(HOME_BODY_CLASS)
    }
  }, [])

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroIndex((prev) => (prev + 1) % heroBackgrounds.length)
    }, 7000)
    return () => clearInterval(timer)
  }, [heroBackgrounds.length])

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setFormStatus({ state: 'loading', error: '' })
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      })
      if (!res.ok) {
        throw new Error('Failed to send message')
      }
      setFormStatus({ state: 'sent', error: '' })
      setFormData({ name: '', phone: '', email: '', subject: '', message: '' })
    } catch (err) {
      setFormStatus({ state: 'error', error: 'Unable to send. Please try again.' })
    }
  }

  const openModal = (key) => {
    setModalClosing(false)
    setActiveModal(key)
  }

  const closeModal = () => {
    setModalClosing(true)
    setTimeout(() => {
      setActiveModal(null)
      setModalClosing(false)
    }, 220)
  }

  const scrollToSection = (id) => {
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const nextBrand = () => {
    if (isBrandAnimating) return
    setBrandDirection('next')
    setIsBrandAnimating(true)
    setBrandOffset(-100)
    if (brandTimer.current) clearTimeout(brandTimer.current)
    brandTimer.current = setTimeout(() => {
      setBrandIndex((prev) => (prev + 1) % brandLogos.length)
      setBrandOffset(0)
      setBrandDirection(null)
      setIsBrandAnimating(false)
    }, 220)
  }

  const prevBrand = () => {
    if (isBrandAnimating) return
    setBrandDirection('prev')
    setIsBrandAnimating(true)
    setBrandOffset(100)
    if (brandTimer.current) clearTimeout(brandTimer.current)
    brandTimer.current = setTimeout(() => {
      setBrandIndex((prev) => (prev - 1 + brandLogos.length) % brandLogos.length)
      setBrandOffset(0)
      setBrandDirection(null)
      setIsBrandAnimating(false)
    }, 220)
  }

  useEffect(() => {
    return () => {
      if (brandTimer.current) clearTimeout(brandTimer.current)
    }
  }, [])

  useEffect(() => {
    const auto = setInterval(() => {
      if (!isBrandAnimating) {
        setBrandDirection('next')
        setIsBrandAnimating(true)
        setBrandOffset(-100)
        if (brandTimer.current) clearTimeout(brandTimer.current)
        brandTimer.current = setTimeout(() => {
          setBrandIndex((prev) => (prev + 1) % brandLogos.length)
          setBrandOffset(0)
          setBrandDirection(null)
          setIsBrandAnimating(false)
        }, 220)
      }
    }, 3000)
    return () => clearInterval(auto)
  }, [brandLogos.length, isBrandAnimating])

  const formatBrandName = (filename) => {
    const base = filename.replace(/\.[^/.]+$/, '')
    return base
      .replace(/[-_]+/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }

  return (
    <div className={styles.page} id="top">
      <section className={styles.hero}>
        <div className={styles.heroSlides}>
          {heroBackgrounds.map((bg, idx) => (
            <div
              key={bg}
              className={`${styles.heroSlide} ${heroIndex === idx ? styles.activeSlide : ''}`}
              style={{
                backgroundImage: `linear-gradient(120deg, rgba(15, 23, 42, 0.82), rgba(15, 23, 42, 0.6)), url(${bg})`,
              }}
            />
          ))}
        </div>
        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <div className={styles.heroCopy}>
              {/* <p className={styles.kicker}>The Northeast's Largest Full Line Distributor</p> */}
              <h1>Wholesale USA</h1>
              <p className={styles.subhead}>
                The Northeast's Largest Full Line Distributor
              </p>
              <div className={styles.ctaRow}>
                <a className={styles.primaryCta} href="tel:15167996404">Call for a quote</a>
                <button className={styles.secondaryCta} type="button" onClick={() => scrollToSection('contact')}>
                  Email our team
                </button>
              </div>
            </div>
            <div className={styles.heroCard}>
              <div className={styles.badge}>
                <img src="images/wholesale_shield.PNG" alt="Wholesale USA logo" />
              </div>
              <div className={styles.cardContent}>
                <p className={styles.cardTitle}>Family owned & operated since 1988</p>
                <p className={styles.cardBody}>Trusted distribution partner for property managers, contractors, builders, and retail dealers.</p>
                <div className={styles.contactList}>
                  <span>Massapequa, NY 11758</span>
                  <span>(516) 799-6404</span>
                  <span>info@wholesaleusany.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.section}>
          <h1>The Northeast's Appliance Supplier</h1>
          <p className={styles.sectionLead}>
          Wholesale USA is a local, family-owned appliance Distributor in New York. We
          sell home appliances, including stoves, refrigerators, freezers, microwaves,
          dishwashers, washers, dryers, and portable air conditioners. With warehouse
          space throughout the Northeast, we have stocked appliances ready for you to
          purchase today. We sell all home appliances, including kitchen appliances
          and laundry appliances. Our friendly, knowledgeable sales professionals will
          help match you with your desired appliance. Our new appliances come with a
          1-year in-home manufacturer warranty, and we provide several extended
          warranty options.
          </p>
          <p className={styles.sectionLead}>
            Wholesale USA offers the best prices on appliances that are hard to find
            elsewhere. With a range of appliances in stock, including black stainless steel
            appliances, there’s something for everyone.
          </p>
      </section>
      <section className={styles.section} id="about">
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>About us</p>
          <h2>Celebrating {yearsInBusiness} Years in Business!</h2>
          <p className={styles.sectionLead}>
            At the heart of Wholesale USA is our sense of family. Since our inception in
            1988 to today, we have made it a priority to foster the kind of business
            relationships that last a lifetime. As a family run business, we know how
            important loyalty is and we are so grateful for our talented team. We believe
            the dedication of our incredible employees and long time customers is the
            key to our shared success over the past {yearsInBusiness} years!
          </p>
          <p className={styles.sectionLead}>
            Since 1988, our company has grown to serve nine states in the Northeast, and
            become the most trusted appliance source for builders, contractors, property
            managers, and retailers who want high quality appliances at competitive
            prices. Our family-owned operation has established a reputation for having
            professionals who are among the most knowledgeable, helpful and honest in
            the industry. Our diverse range of customers have found that when choosing
            among various appliance dealers online and in the area, we are a company
            they can trust.
          </p>
        </div>
      </section>

      <section className={styles.section} id="services">
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>Services</p>
          <h2>What we handle for you</h2>
          <p className={styles.sectionLead}>End-to-end wholesale support so you can focus on your stores.</p>
        </div>

        <div className={styles.serviceRows}>
          <div className={`${styles.serviceRow}`} id="services-property-managers">
            <div className={styles.serviceText}>
              <p className={styles.kicker}>Your Trusted Appliance Dealer for Property Management Companies</p>
              <h3>Reliable Appliance Solutions for Property Managers</h3>
              <p>
                We specialize in providing high-quality appliances to property management
                companies. Whether you oversee multi-unit apartment buildings,
                condominiums, or single-family rental homes, we offer cost-effective, durable,
                and energy-efficient appliances to meet your tenants' needs.
              </p>
              <button className={styles.secondaryCta} type="button" onClick={() => openModal('property')}>
                Learn more
              </button>
            </div>
            <div className={styles.serviceImage} aria-hidden="true">
              <img src="images/PropertyManagement.jpg" alt="" />
            </div>
          </div>

          <div className={`${styles.serviceRow} ${styles.reverse}`} id="services-builders">
            <div className={styles.serviceText}>
              <p className={styles.kicker}>Contractors / Builders</p>
              <h3>Your Trusted Supplier for New Build Appliances</h3>
              <p>
               Wholesale USA specializes in supplying appliances to general contractors,
                builders, and developers for residential and commercial projects. Whether
                you're constructing new homes, renovating apartments, or outfitting multi-
                unit developments, we provide reliable, cost-effective, and high-performance
                appliances tailored to your needs
              </p>
              <button className={styles.secondaryCta} type="button" onClick={() => openModal('builders')}>
                Learn more
              </button>
            </div>
            <div className={styles.serviceImage} aria-hidden="true">
              <img src="images/GeneralContractors.jpg" alt="" />
            </div>
          </div>

          <div className={styles.serviceRow} id="services-retail-dealers">
            <div className={styles.serviceText}>
              <p className={styles.kicker}>Retail dealers</p>
              <h3>Your Reliable Supplier for Retail Dealers</h3>
              <p>
                At Wholesale USA, we have built our success side-by-side with Independent
                Retail Appliance and Electronics Dealers by fostering strong relationships.
                Our Retail Dealers Division is committed to forging partnerships with
                Independent Retailers and Local Small Businesses, with an emphasis on
                reliability and integrity.
              </p>
              <button className={styles.secondaryCta} type="button" onClick={() => openModal('retail')}>
                Learn more
              </button>
            </div>
            <div className={styles.serviceImage} aria-hidden="true">
              <img src="images/Landlords.jpg" alt="" />
            </div>
          </div>
        </div>
      </section>

      {activeModal && (
        <div className={`${styles.modalOverlay} ${modalClosing ? styles.fadeOut : styles.fadeIn}`} onClick={closeModal}>
          <div className={`${styles.modal} ${modalClosing ? styles.fadeOut : styles.fadeIn}`} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={closeModal} aria-label="Close">×</button>
            {activeModal === 'property' && (
              <div className={styles.modalCard}>
                <div className={styles.modalImage}>
                  <img src="images/PropertyManagement.jpg" alt="" />
                </div>
                <div className={styles.modalBody}>
                  <p className={styles.kicker}>Property management</p>
                  <h3>Reliable Appliance Solutions for Property Managers</h3>
                  <p>
                    At Wholesale USA, we specialize in providing high-quality appliances to property management companies.
                    Whether you oversee multi-unit apartment buildings, condominiums, or single-family rental homes,
                    we offer cost-effective, durable, and energy-efficient appliances to meet your tenants&#39; needs.
                  </p>
                  <p>Why partner with us?</p>
                  <ul>
                    <li><strong>Selection &amp; Availability</strong> – With Warehouses throughout the Northeast,
                        we stock all types of appliances from basic, budget-friendly models to
                        top-of-the-line stainless steel luxury appliances.</li>
                    <li><strong>Industry Leading Pricing</strong> – Save more with our exclusive volume
                        discounts and property management pricing plans.</li>
                    <li><strong>Fast &amp; Efficient Fulfillment </strong>– We prioritize quick order processing and
                    timely delivery to minimize downtime for your properties.</li>
                    <li><strong>Turnkey Appliance Packages</strong> – Need to outfit multiple units? We offer
                        tailored appliance packages designed for rental properties.</li>
                    <li>
                        <strong>Five Star Service</strong> – From In-Unit Delivery, to Uncrating, and Old
                        Appliance Removal, we handle everything for a seamless experience.
                    </li>
                  </ul>
                  <h3>Appliances, Air Conditioners, &amp; Electronics</h3>
                  <p>
                    We offer and stock popular product lines that your customers need. Whether
upgrading appliances, or buying a Window AC Unit during a heat wave, we
have you covered.
                  </p>
                  <h3>Serving Property Managers Across the Northeast</h3>
                  <p>
                    No matter where your rental property is located, Wholesale USA provides
                    professional service and top-tier appliances to landlords from Washington
                    D.C. to Boston, MA.
                  </p>
                  <p>
                    Let Wholesale USA be your go-to appliance supplier—because quality,
                      affordability, and convenience matter.
                  </p>
                </div>
              </div>
            )}
            {activeModal === 'builders' && (
              <div className={styles.modalCard}>
                <div className={styles.modalImage}>
                  <img src="images/GeneralContractors.jpg" alt="" />
                </div>
                <div className={styles.modalBody}>
                  <p className={styles.kicker}>Contractors / Builders</p>
                  <h3>Your Trusted Supplier for New Build Appliances</h3>
                  <p>
                     At Wholesale USA, we specialize in working with builders of all sizes, from
                      single-family custom homes to four-unit condo conversions to 600-unit
                      multi-family residential buildings. Every builder who partners with us benefits
                      from our expert team, who strive to keep their projects on time and on
                      budget .
                  </p>
                 <p>Why choose Wholesale USA?</p>
                  <ul>
                    <li><strong>Industry Leading Pricing</strong> – Get high-quality appliances at unbeatable
                      prices to maximize your return on investment.</li>
                    <li><strong>Bulk Discounts</strong> – Outfitting multiple rental units? Take advantage of
                      our exclusive bulk pricing options.</li>
                    <li><strong>Fast &amp; Reliable Delivery</strong>– Since time is money, we ensure quick
                      turnaround times, so your sites experience minimal disruption.</li>
                    <li><strong>Wide Selection of Appliances</strong> – From refrigerators and stoves to
                        washers and dryers, we carry top brands to suit every property.</li>
                    <li>
                        <strong>In-Unit Delivery &amp; Uncrating</strong> – Save time with our hassle-free In-Unit
                        Delivery, and we’ll even take away the box and styrofoam.
                    </li>
                    <li>
                        <strong>Durable &amp; Tenant-Friendly Products</strong> – Our appliances are built to
                        withstand rental use, ensuring longevity and easy maintenance.
                    </li>
                  </ul>
                  <h3>Appliance Packages for Matching Units</h3>
                  <p>
                    We offer customized appliance packages based on the size and type of your
                    rental unit. Whether you need a basic appliance set for an economy rental or
                    premium options for high-end properties, we have you covered.
                  </p>
                  <h3>Serving Builders Across the Northeast</h3>
                  <p>
                   No matter where your rental property is located, Wholesale USA provides
                    professional service and top-tier appliances to landlords from Washington
                    D.C. to Boston, MA.
                  </p>
                  <p>
                    Let Wholesale USA be your go-to appliance supplier—because quality,
                      affordability, and convenience matter.
                  </p>
                </div>
              </div>
            )}
            {activeModal === 'retail' && (
              <div className={styles.modalCard}>
                <div className={styles.modalImage}>
                  <img src="images/Landlords.jpg" alt="" />
                </div>
                <div className={styles.modalBody}>
                  <p className={styles.kicker}>Retail dealers</p>
                  <h3>Your Reliable Supplier for Retail Dealers</h3>
                  <p>
                    At Wholesale USA, we have built our success side-by-side with Independent
                    Retail Appliance and Electronics Dealers by fostering strong relationships.
                    Our Retail Dealers Division is committed to forging partnerships with
                    Independent Retailers and Local Small Businesses, with an emphasis on
                    reliability and integrity.
                  </p>
                  <p>Why choose Wholesale USA?</p>
                   <ul>
                    <li><strong>Industry Leading Pricing</strong> – Get high-quality appliances at unbeatable
                        prices to maximize your profits.</li>
                    <li><strong>Fast &amp; Reliable Delivery</strong> – As soon as Next Day Delivery, your customers
                      won’t have to wait or shop around.</li>
                    <li><strong>Popular Appliances In Stock</strong>– We have our most popular models in
                        inventory so ensure quick turnaround.</li>
                    <li><strong>Consumer Delivery</strong> – Save time and let us deliver to your customer in
                      select markets.</li>
                  </ul>
                  <h3>Appliances, Air Conditioners, &amp; Electronics</h3>
                  <p>
                    We offer and stock popular product lines that your customers need. Whether
                    upgrading appliances, or buying a Window AC Unit during a heat wave, we
                    have you covered.
                  </p>
                  <h3>Serving Retail Dealers Across the Northeast</h3>
                  <p>
                   No matter where your rental property is located, Wholesale USA provides
                    professional service and top-tier appliances to landlords from Washington
                    D.C. to Boston, MA.
                  </p>
                  <p>
                    Let Wholesale USA be your go-to appliance supplier—because quality,
                      affordability, and convenience matter.
                  </p>
                </div>
              </div>
            )}
            <div className={styles.modalActions}>
              <button className={styles.secondaryCta} type="button" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      <section className={styles.section} id="brands">
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>Brands</p>
          <h2>Brands We Carry</h2>
          <p className={styles.sectionLead}>Call or e-mail for inquiries about any brand you do not see.</p>
        </div>
        <div className={styles.brandGrid}>
          {brandLogos.map((logo) => (
            <div key={logo} className={styles.brandCard}>
              <img
                src={`images/brand_logos/${logo}`}
                alt={`${formatBrandName(logo)} logo`}
                className={styles.brandLogo}
              />
            </div>
          ))}
        </div>
        <div className={styles.brandCarousel}>
          <button className={styles.brandCarouselControl} type="button" aria-label="Previous brand" onClick={prevBrand}>
            ‹
          </button>
          <div className={styles.brandCarouselFrame}>
            <div
              className={`${styles.brandCarouselTrack} ${brandDirection === 'next' ? 'animating-next' : ''} ${brandDirection === 'prev' ? 'animating-prev' : ''}`}
              style={{
                transform: `translateX(${brandOffset}%)`,
                transition: isBrandAnimating ? 'transform 220ms ease' : 'none',
              }}
            >
              {[
                (brandIndex - 1 + brandLogos.length) % brandLogos.length,
                brandIndex,
                (brandIndex + 1) % brandLogos.length,
              ].map((idx, i) => (
                <div
                  key={`${idx}-${i}`}
                  className={`${styles.brandItem} ${
                    i === 1 ? styles.brandItemActive : i === 0 ? styles.brandItemPrev : styles.brandItemNext
                  }`}
                >
                  <img
                    src={`images/brand_logos/${brandLogos[idx]}`}
                    alt={`${formatBrandName(brandLogos[idx])} logo`}
                    className={styles.brandLogo}
                  />
                </div>
              ))}
            </div>
          </div>
          <button className={styles.brandCarouselControl} type="button" aria-label="Next brand" onClick={nextBrand}>
            ›
          </button>
        </div>
      </section>

      <section className={styles.section} id="contact">
        <div className={styles.sectionHeader}>
          <p className={styles.kicker}>Contact us</p>
          <p className={styles.sectionLead}>Call or email and we’ll share availability, pricing, and routes for your stores.</p>
        </div>

        <div className={styles.contactCardCombined}>
          <div className={styles.contactIntro}>
            <h3>Contact Wholesale USA</h3>
            <div className={styles.contactList}>
              <a href="tel:15167996404">Phone: (516) 799-6404</a>
              <a href="mailto:info@wholesaleusany.com">Email: info@wholesaleusany.com</a>
              <span>Massapequa, NY 11758</span>
            </div>
            <div className={styles.ctaRow}>
              <a className={styles.primaryCta} href="tel:15167996404">Call now</a>
              <a className={styles.secondaryCta} href="mailto:info@wholesaleusany.com">Email us</a>
            </div>
          </div>

          <div className={styles.contactFormWrapper}>
            <h3>Send us a message</h3>
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              <div className={styles.formRow}>
                <label>
                  Name
                  <input name="name" value={formData.name} onChange={handleChange} required />
                </label>
                <label>
                  Phone
                  <input name="phone" value={formData.phone} onChange={handleChange} />
                </label>
              </div>
              <div className={styles.formRow}>
                <label>
                  Email
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </label>
                <label>
                  Subject
                  <input name="subject" value={formData.subject} onChange={handleChange} required />
                </label>
              </div>
              <label className={styles.fullRow}>
                Message
                <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required />
              </label>
              <div className={styles.formActions}>
                <button type="submit" className={styles.primaryCta} disabled={formStatus.state === 'loading'}>
                  {formStatus.state === 'loading' ? 'Sending...' : 'Send message'}
                </button>
                {formStatus.state === 'sent' && <span className={styles.formSuccess}>Message sent!</span>}
                {formStatus.state === 'error' && <span className={styles.formError}>{formStatus.error}</span>}
              </div>
            </form>
          </div>
        </div>
      </section>

      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrand}>
            <img src="images/wholesale_shield.PNG" alt="Wholesale USA shield" />
            <div>
              <p className={styles.footerName}>Wholesale U.S.A.</p>
              <p className={styles.footerTag}>The Northeast's Largest Full Line Disributor</p>
            </div>
          </div>
          <div className={styles.footerColumn}>
            <h4 style={{paddingLeft: 0, paddingTop: 0}}>Explore</h4>
            <a href="#about">About</a>
            <a href="#services">Services</a>
            <a href="#contact">Contact</a>
          </div>
          <div className={styles.footerColumn}>
            <h4 style={{paddingLeft: 0, paddingTop: 0}}>Contact</h4>
            <a href="tel:15167996404">(516) 799-6404</a>
            <a href="mailto:info@wholesaleusany.com">info@wholesaleusany.com</a>
            <span>Massapequa, NY 11758</span>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <span>Wholesale USA © 2022</span>
          <a href="#top">Back to top</a>
        </div>
      </footer>
      {showScrollTop && (
        <button className={styles.scrollTop} onClick={scrollToTop} aria-label="Scroll to top" type="button">
          ↑
        </button>
      )}
    </div>
  )
}

export default Home
